/**
 * Faz 9 (yapay zekâ, öneri motoru, talep tahmini) ekranlarının yardım metinleri. Faz 8 ayrı dalda geliştirildiği için
 * ayrı dosyada tutulur; entries.tr.ts ve entries.en.ts bu kayıtları kendi listelerinin başına yayar.
 */
import type { HelpContent } from './entries.tr';

const G = 'docs/AI_STUDIO_TR.md';

export const AI_HELP_TR = {
  'page.ai_settings': {
    kind: 'page',
    title: 'Yapay zekâ ayarları',
    short: 'Yapay zekâyı açma/kapama, aylık harcama sınırı, modeller, fiyat tablosu ve kullanım raporu.',
    whatItDoes:
      'Yapay zekâ ücretli bir dış hizmettir (metin: Anthropic Claude, görsel: OpenAI). Anahtarlar Entegrasyonlar ekranından girilir; burada sahip aylık sınırı yazıp açık onay verir. Her istekten önce en kötü durum maliyeti ayrılır, sınır aşılacaksa istek gönderilmez. Kullanım raporunda her isteğin amacı, modeli, token sayısı ve tahmini maliyeti görünür; istem ve yanıt metni kaydedilmez.',
    whenToUse: 'İlk kurulumda, sınırı değiştirirken ve aylık harcamayı kontrol ederken.',
    dataChanged: 'Ayarlar kaydedilir ve denetim kaydına düşer. Rapor hiçbir veriyi değiştirmez.',
    requiredPermission:
      'Görüntüleme: Yapay zekâ kullanımını görüntüleme. Açma, kapama ve ayarlar: Yapay zekâyı açma/kapatma (iki adımlı doğrulama).',
    guideUrl: `${G}#acma`,
  },
  'ai.enable': {
    kind: 'action',
    title: 'Yapay zekâyı aç',
    short:
      'Aylık harcama sınırını yazıp ücretli hizmeti açtığınızı onaylarsınız. Ancak bundan sonra sağlayıcıya istek gönderilir.',
    whatItDoes:
      'Tahmini harcama sınıra ulaşınca yeni istek gönderilmez. Kim, ne zaman, hangi sınırla açtı denetim kaydına yazılır. Sağlayıcının kendi konsolunda da bir sınır koymanız önerilir.',
    requiredPermission: 'Yapay zekâyı açma/kapatma ve harcama sınırı (iki adımlı doğrulama)',
    reversible: 'Evet: Kapat düğmesiyle istediğiniz an kapatılır.',
    commonErrors: [
      {
        problem: 'Onay kutusu işaretlenmedi',
        solution: 'Ücretli hizmeti açtığınızı onaylayan kutuyu işaretleyin.',
      },
    ],
    guideUrl: `${G}#acma`,
  },
  'ai.disable': {
    kind: 'action',
    title: 'Yapay zekâyı kapat',
    short: 'Yeni istek gönderilmez; ayarlar ve kullanım kaydı korunur.',
    requiredPermission: 'Yapay zekâyı açma/kapatma ve harcama sınırı',
    reversible: 'Evet: yeniden açabilirsiniz (onay yeniden istenir).',
    guideUrl: `${G}#acma`,
  },
  'ai.limits': {
    kind: 'field',
    title: 'Harcama ve istek sınırları',
    short:
      'Aylık sınır USD cinsinden tahmini harcamadır; günlük sınır istek sayısıdır. İkisinden biri dolunca düğmeler "sınır doldu" der.',
    whatItDoes:
      'Harcama, sağlayıcının bildirdiği token sayıları ile fiyat tablosundan hesaplanır ve yukarı yuvarlanır. Ay ve gün İstanbul saatine göre başlar.',
    guideUrl: `${G}#acma`,
  },
  'ai.models': {
    kind: 'field',
    title: 'Modeller',
    short:
      'Uzun metinler için metin modeli, başlık/meta/alt metin gibi kısa işler için daha ucuz model, görsel için görsel modeli.',
    whatItDoes:
      'Fiyatı fiyat tablosunda olmayan model seçilemez; yeni bir model kullanmak için önce fiyatını ekleyin.',
    guideUrl: `${G}#modeller`,
  },
  'ai.prices': {
    kind: 'field',
    title: 'Fiyat tablosu',
    short:
      '1 milyon token için girdi ve çıktı ücreti (USD). Varsayılanlar sağlayıcıların fiyat sayfasından alındı; değişirse güncelleyin.',
    reversible: 'Evet: "Varsayılana dön" ile özel fiyat kaldırılır.',
    guideUrl: `${G}#modeller`,
  },
  'ai.usage': {
    kind: 'field',
    title: 'Kullanım raporu',
    short:
      'Sağlayıcıya giden her istek: amaç, model, sonuç, token, tahmini maliyet, kullanıcı, maskelenen kişisel veri ve sağlık beyanı sayısı.',
    whatItDoes: 'İstem ve yanıt metni kaydedilmez. Askıdaki istekler ayrılan üst sınırla sayılır.',
    guideUrl: `${G}#kullanim`,
  },
  'ai.supportDrafts': {
    kind: 'field',
    title: 'Destek taslaklarında müşteri mesajı',
    short:
      'Açıksa destek yanıt taslağı için müşterinin mesajı maskelenerek yapay zekâya gönderilir. Varsayılan kapalı.',
    whatItDoes:
      'E-posta, telefon, kimlik no, IBAN ve kart numarası maskelenir; ad ve adres ayıklanamaz. Açmadan önce yurt dışı aktarım envanterini ve aydınlatma metnini avukatınızla güncelleyin.',
    guideUrl: `${G}#destek-taslaklari`,
  },
  'page.ai_recommendations': {
    kind: 'page',
    title: 'Ürün önerileri',
    short:
      'Vitrindeki "Bunu alanlar bunları da aldı", sepet önerisi ve Hesabım\'daki "Yeniden alım zamanı" bölümlerinin ayarları ve sonuçları.',
    whatItDoes:
      "Yapay zekâ kullanmaz ve ücretsizdir. Her gece 04:25'te son 365 günün ödenmiş, iptal edilmemiş siparişlerinden birlikte alınan ürün çiftleri hesaplanır. Bir ilişki ancak en az 3 farklı müşterinin siparişinde geçtiyse ve rastlantıdan sık ise (kaldıraç > 1) kullanılır. Veri yetersizse vitrinde ilgili bölüm görünmez; sahte veya örnek öneri gösterilmez.",
    whenToUse: 'Önerilerin nasıl oluştuğunu görmek, bölümleri açıp kapamak ve eşikleri değiştirmek için.',
    dataChanged: 'Ayarlar denetim kaydına düşer; "Şimdi hesapla" öneri tablosunu yeniden yazar.',
    requiredPermission: 'Görüntüleme: Ürünleri görüntüleme. Ayarlar ve hesaplama: Ürünleri düzenleme.',
    guideUrl: `${G}#oneriler`,
  },
  'recommendations.run': {
    kind: 'action',
    title: 'Şimdi hesapla',
    short: 'Önerileri gece işini beklemeden yeniden hesaplar (eski ilişkiler silinip yenileri yazılır).',
    reversible: 'Gerekmez: her hesaplama güncel siparişlerden baştan yapılır.',
    guideUrl: `${G}#oneriler`,
  },
  'recommendations.pairs': {
    kind: 'field',
    title: 'En güçlü ilişkiler',
    short:
      'Her ürünün en güçlü ilişkisi: farklı alıcı sayısı, güven (ürünü alanların diğerini de alma oranı) ve kaldıraç (rastlantıya göre kaç kat sık).',
    guideUrl: `${G}#oneriler`,
  },
  'recommendations.settings': {
    kind: 'field',
    title: 'Öneri ayarları',
    short:
      'Bölümleri aç/kapa, değerlendirilen dönem, en az farklı alıcı (gizlilik), en az güven, ürün başına en çok öneri ve bayi siparişleri.',
    guideUrl: `${G}#oneriler`,
  },
  'page.ai_forecast': {
    kind: 'page',
    title: 'Talep tahmini',
    short:
      'Her ürün varyantının tahmini satışı, mevcut stokun kaç gün yeteceği, önerilen sipariş miktarı ve son kullanma tarihi riski.',
    whatItDoes:
      'Yapay zekâ kullanmaz. Ödenmiş, iptal edilmemiş gerçek siparişlerin haftalık satışından hesaplanır: düzenli satılan ürünlerde üstel düzeltme, seyrek satılanlarda Croston yöntemi. Yeniden sipariş noktası = günlük tahmin × (tedarik süresi + emniyet günü); önerilen miktar stoğu bir sonraki gözden geçirme dönemine de yetecek düzeye getirir. SKT riski: lotlar en yakın tarihliden başlayarak satılırsa tarihine kadar satılamayacak adet. Satın alma emri oluşturmaz (Faz 8).',
    whenToUse: 'Haftalık sipariş planı yaparken ve son kullanma tarihi yaklaşan lotları erken görmek için.',
    dataChanged: 'Liste hiçbir veriyi değiştirmez. Varsayılanlar ve varyant ayarları denetim kaydına düşer.',
    requiredPermission: 'Görüntüleme: Stok görüntüleme. Ayarlar: Stok yönetimi.',
    guideUrl: `${G}#talep-tahmini`,
  },
  'forecast.accuracy': {
    kind: 'field',
    title: 'Tahmin hatası (WAPE)',
    short:
      'Dört hafta önceki veriyle yapılan tahminin son dört haftada gerçekleşen satıştan ne kadar saptığı (toplam sapma ÷ toplam satış). Küçük olan iyidir.',
    guideUrl: `${G}#talep-tahmini`,
  },
  'forecast.table': {
    kind: 'field',
    title: 'Tahmin listesi',
    short:
      'Önce tükenen ve sipariş zamanı gelenler. "Ayarla" ile ürüne özel tedarik süresi ve emniyet günü girilir veya ürün tahminden çıkarılır.',
    guideUrl: `${G}#talep-tahmini`,
  },
  'forecast.on_order': {
    kind: 'field',
    title: 'Yolda',
    short:
      'Tedarikçiye verilmiş satın alma siparişlerinde henüz teslim alınmamış adet; altında talepteki (henüz verilmemiş) adet. İkisi de önerilen miktardan düşülür; yeterliyse durum "Siparişi verildi" olur. Tedarik süresi ürüne özel değer yoksa son siparişin tedarikçisinden gelir.',
    guideUrl: `${G}#talep-tahmini`,
  },
  'forecast.settings': {
    kind: 'field',
    title: 'Tahmin varsayılanları',
    short:
      'Değerlendirilen geçmiş, varsayılan tedarik süresi ve emniyet günü, gözden geçirme dönemi, fazla stok eşiği ve bayi siparişleri.',
    guideUrl: `${G}#talep-tahmini`,
  },
  'page.content_studio': {
    kind: 'page',
    title: 'İçerik Stüdyosu',
    short:
      'Makaleleri 27 adımlık süreçle hazırlama: konu ve kaynaktan plana, taslaktan SEO, görsel ve kalite kontrolüne.',
    whatItDoes:
      'Her makale bir projedir. Konu, hedef kitle, anahtar kelime ve kaynaklarla başlar; plan, başlık, taslak ve SEO alanları elle veya isteğe bağlı yapay zekâ önerisiyle doldurulur. Tekrar kontrolü, kaynak doğrulama, iç bağlantı önerisi ve kalite kontrolü yapay zekâsızdır. Bitince blog yazısına taslak olarak aktarılır; yayın, editör ve veteriner onayı blog ekranında yapılır.',
    whenToUse: 'Yeni blog yazısı planlarken ve yayındaki yazıları performansa göre güncellerken.',
    dataChanged:
      'Projeler ayrı tutulur; blog yalnızca "Blog yazısına aktar" ile değişir. Her işlem denetim kaydına düşer.',
    requiredPermission:
      'Görüntüleme: İçerik görüntüleme. Düzenleme ve aktarım: İçerik düzenleme. Yapay zekâ adımları: ayrıca Yapay zekâ ile taslak üretme.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'page.content_studio_project': {
    kind: 'page',
    title: 'Makale projesi',
    short:
      'Bir makalenin 27 adımı: hangi adımın tamamlandığı ve hangisinde yapay zekâ kullanıldığı üstte görünür.',
    whatItDoes:
      'Alanları doldurup "Kaydet" ile kaydedin. Yapay zekâ düğmeleri yalnızca kayıtlı hâl üzerinde çalışır ve dolu alanın üzerine yazmadan önce onay ister. Kalite kontrolü kaydedilen hâle göre güncellenir.',
    requiredPermission: 'İçerik düzenleme; yapay zekâ adımları için ayrıca Yapay zekâ ile taslak üretme.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.create': {
    kind: 'action',
    title: 'Yeni makale projesi',
    short:
      'Konu, hedef kitle, dil, ülke, anahtar kelime ve arama niyetiyle yeni bir proje açar. Blogda hiçbir şey değişmez.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.brief': {
    kind: 'field',
    title: 'Konu ve hedef',
    short:
      'Yazının cevaplayacağı soru, kime yazıldığı, hedef ülke ve arama niyeti. Yapay zekâ önerileri bu bilgilere dayanır.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.keyword': {
    kind: 'field',
    title: 'Anahtar kelime',
    short: 'Yazının hedeflediği arama. Anahtar kelime havuzundan seçilirse arama niyeti de oradan gelir.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.health': {
    kind: 'field',
    title: 'Sağlık / takviye içeriği',
    short:
      'İşaretliyse kaynak zorunludur ve blog yazısı Veteriner Uzman İnceleyici onayı olmadan yayımlanamaz.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Projedeki değişiklikleri kaydeder. Başka biri aynı anda kaydettiyse uyarı verir; sayfayı yenileyip yeniden deneyin.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.steps': {
    kind: 'field',
    title: '27 adım',
    short:
      'Her adımın durumu kayıttaki gerçek veriden hesaplanır; yıldız simgesi o adımda yapay zekâ kullanıldığını gösterir.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.sources': {
    kind: 'field',
    title: 'Kaynaklar',
    short:
      'Yazının dayandığı kaynaklar (en çok 20). Yapay zekâ yalnızca bunlara [1], [2] biçiminde atıf yapabilir; kaynak uyduramaz.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.verify': {
    kind: 'action',
    title: 'Kaynakları doğrula',
    short:
      'Her kaynak sunucudan açılır: erişilebilir mi, nereye yönleniyor, sayfa başlığı ne. İçerik kaydedilmez; iç ağ adresleri engellenir.',
    commonErrors: [
      {
        problem: 'Erişilemedi',
        solution:
          'Adresi tarayıcıda açıp kontrol edin; site geçici olarak kapalı olabilir veya otomatik erişimi engelliyor olabilir.',
      },
    ],
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.duplicates': {
    kind: 'action',
    title: 'Tekrar kontrolü',
    short:
      'Mağazanın aynı dildeki blog yazıları ve sayfalarıyla başlık benzerliğine bakar (Türkçe karakterden bağımsız). %60 üstü uyarıdır.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.ai_plan': {
    kind: 'action',
    title: 'Yapay zekâ ile plan ve başlık',
    short:
      'Konu, kitle, anahtar kelime ve kaynak listesinden kısa bir plan ve H2/H3 başlık önerisi alır. Ücretli istektir; aylık sınıra sayılır.',
    dataChanged:
      'Plan ve başlık alanları öneriyle değişir (doluysa onay istenir). Kullanım kaydı tutulur; istem ve yanıt kaydedilmez.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.ai_draft': {
    kind: 'action',
    title: 'Yapay zekâ ile taslak',
    short:
      'Başlıklara göre Markdown taslak yazdırır. Önce başlıklar gerekir. Sağlık beyanı bulunursa ekranda listelenir.',
    dataChanged: 'Taslak alanı öneriyle değişir (doluysa onay istenir).',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.draft': {
    kind: 'field',
    title: 'Taslak',
    short:
      'Markdown: ## ile H2, ### ile H3, [metin](/urun/adres) ile iç bağlantı. Aktarımda blog belgesine çevrilir; ham HTML çalıştırılmaz.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.links': {
    kind: 'field',
    title: 'İç bağlantılar',
    short:
      'Konuyla eşleşen yayındaki ürün, kategori ve yazılar önerilir (yapay zekâsız). Seçilenler yapay zekâ taslağına bağlantı adayı olarak verilir.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.related': {
    kind: 'field',
    title: 'İlgili ürünler',
    short: 'Blog yazısının altında gösterilecek ürünler (en çok 8). Aktarımda yazıya geçer.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.ai_meta': {
    kind: 'action',
    title: 'Yapay zekâ ile SEO önerisi',
    short: 'SEO başlığı, meta açıklama, adres ve etiket önerisi alır (daha ucuz kısa işler modeli).',
    dataChanged: 'SEO başlığı, meta açıklama, adres ve etiketler öneriyle değişir (doluysa onay istenir).',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.seo': {
    kind: 'field',
    title: 'SEO alanları',
    short:
      'SEO başlığı en çok 70, meta açıklama en çok 170 karakter. Adres küçük harf, rakam ve tireden oluşur.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.images': {
    kind: 'field',
    title: 'Görseller',
    short:
      'Kapak görseli ve alt metni blog yazısına aktarılır. Her görselin alt metni olmalıdır (erişilebilirlik ve SEO).',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.quality': {
    kind: 'field',
    title: 'Kalite kontrolü',
    short:
      'Başlık ve açıklama uzunluğu, kelime sayısı, başlık yapısı, anahtar kelime, iç bağlantı, kaynak, görsel alt metni, sağlık beyanı ve tekrar.',
    whatItDoes:
      '"Eksik" maddeler aktarımı engellemez ama 23. adım tamamlanmış sayılmaz. Sağlık beyanı olan yazı blogda veteriner onayına düşer.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.export': {
    kind: 'action',
    title: 'Blog yazısına aktar',
    short:
      'Blogda yeni bir taslak oluşturur veya bağlı yazının taslağını günceller. Yayındaki yazı değişmez; yayın blog ekranından yapılır.',
    reversible: 'Evet: blog taslağı sürüm geçmişiyle tutulur; yayımlanmadıkça vitrine çıkmaz.',
    commonErrors: [
      {
        problem: 'Adres kullanımda',
        solution: 'Adres (slug) alanını değiştirip kaydedin, sonra yeniden aktarın.',
      },
    ],
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.disclosure': {
    kind: 'field',
    title: 'Yapay zekâ desteği notu',
    short:
      'Plan, taslak veya SEO adımında yapay zekâ kullanıldıysa yazının sonuna "yapay zekâ desteğiyle hazırlandı" notu eklenir. Varsayılan açık.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.archive': {
    kind: 'action',
    title: 'Projeyi arşivle',
    short: 'Proje listeden kalkar ve değiştirilemez. Bağlı blog yazısı etkilenmez.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.performance': {
    kind: 'field',
    title: 'Performans',
    short:
      'Yayındaki yazının Search Console verisi: son 28 gün ve önceki 28 gün tıklama, gösterim, tıklama oranı, ortalama konum ve sorgular.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.suggestions': {
    kind: 'field',
    title: 'Güncelleme önerileri',
    short:
      'Kurala dayalı öneriler: bir yıldır güncellenmeyen yazı, trafik düşüşü, düşük tıklama oranı, ilk sayfaya yakın konum, yazıda geçmeyen sorgular, eski kaynak doğrulaması.',
    guideUrl: `${G}#icerik-studyosu`,
  },
  'studio.ai_cover': {
    kind: 'action',
    title: 'Yapay zekâ ile kapak görseli',
    short:
      'Yazdığınız tarife göre özgün kapak görseli üretir (OpenAI Images). Ücretli istektir; görsel başına üst sınır ayarlardadır.',
    whatItDoes:
      'Tarifinize sistem şu kuralları ekler: görselde metin, logo, marka ve tanınabilir kişi olmaz; ilaç, şırınga veya tedavi sahnesi olmaz. Görsel WebP\'ye çevrilir, içine "yapay zekâ ile üretildi" (IPTC) bilgisi yazılır ve kaynağı kalıcı olarak "Yapay zekâ ile üretildi" kaydedilir; vitrinde görselin altında bu not görünür.',
    dataChanged:
      'Yeni bir görsel dosyası oluşur ve projenin kapağı olur (doluysa onay istenir). Kullanım raporuna yazılır.',
    guideUrl: `${G}#gorsel-uretimi`,
  },
  'studio.ai_image': {
    kind: 'action',
    title: 'Yapay zekâ ile içerik görseli',
    short:
      'Makale içinde kullanılacak özgün görsel üretir ve içerik görsellerine ekler (en çok 20). "Taslağa ekle" ile metne yerleştirin.',
    guideUrl: `${G}#gorsel-uretimi`,
  },
  'studio.ai_alt': {
    kind: 'action',
    title: 'Yapay zekâ ile alt metin',
    short:
      'Görsel, kısa işler modeline gösterilir ve görme engelli okuyucular için tek cümlelik alt metin önerilir. Alanı doldurur; kaydetmeden önce kontrol edin.',
    dataChanged: 'Yalnızca form alanı dolar; "Kaydet" ile kaydedilir. Ücretli istektir.',
    guideUrl: `${G}#gorsel-uretimi`,
  },
  'studio.provenance': {
    kind: 'action',
    title: 'Kaynak ve lisans',
    short:
      'Yüklediğiniz görselin kaynağı (kendi çekiminiz, lisanslı stok, tedarikçi), lisansı, telif/atıf ve kaynak adresi. Yapay zekâ ile üretilen görselin kaynağı değiştirilemez.',
    guideUrl: `${G}#gorsel-uretimi`,
  },
  'studio.insert_image': {
    kind: 'action',
    title: 'Taslağa ekle',
    short:
      'Görseli taslağın sonuna bir satır olarak ekler; satırı metinde istediğiniz yere taşıyın. Aktarımda blog yazısında o noktada görsel olur.',
    guideUrl: `${G}#gorsel-uretimi`,
  },
  'ai.draft_product': {
    kind: 'action',
    title: 'Yapay zekâ ile açıklama taslağı',
    short:
      'Ürünün kayıtlı bilgilerinden (ad, marka, tür, kategori, özellikler, bileşim, kullanım, uyarılar) kısa ve uzun açıklama taslağı yazar. Bilgi uydurmaz; sağlık beyanı bulunursa uyarır.',
    dataChanged: '"Alanlara uygula" yalnızca formu doldurur; "Kaydet" ile kaydedilir. Ücretli istektir.',
    guideUrl: `${G}#taslaklar`,
  },
  'ai.draft_translate': {
    kind: 'action',
    title: 'Yapay zekâ ile çevir',
    short:
      'Seçtiğiniz dildeki kardeş yazının taslağını bu yazının diline çevirir: başlık, özet, SEO alanları ve metin. Bağlantılar, görseller ve yapı korunur.',
    dataChanged: 'Yalnızca form dolar; kontrol edip "Kaydet" ile kaydedin. Ücretli istektir.',
    guideUrl: `${G}#taslaklar`,
  },
  'ai.draft_email': {
    kind: 'action',
    title: 'Yapay zekâ ile konu önerisi',
    short:
      'Kampanyanın amacına göre üç konu satırı, ön metin ve giriş paragrafı önerir. Aciliyet uydurmaz, spam ifadelerinden kaçınır.',
    dataChanged: 'Seçtiğiniz öneri forma yazılır; kampanya gönderilmez. Ücretli istektir.',
    guideUrl: `${G}#taslaklar`,
  },
  'ai.draft_support': {
    kind: 'action',
    title: 'Yapay zekâ ile yanıt taslağı',
    short:
      'Talebin konusu, kategorisi, sipariş durumu ve son mesajlarından yanıt taslağı yazar. Sahip ayarlardan açmadıysa görünmez.',
    whatItDoes:
      'Müşteri mesajı dış hizmete gider: iç notlar gönderilmez, müşterinin adı "Müşteri" ile değiştirilir; e-posta, telefon, kimlik no, IBAN ve kart numarası maskelenir. Taslak iade, indirim veya tarih sözü vermez; bilinmeyen sipariş bilgisini uydurmaz.',
    dataChanged: 'Yalnızca yanıt alanı dolar; göndermeden önce okuyun. Ücretli istektir.',
    guideUrl: `${G}#destek-taslaklari`,
  },
  'ai.ad_suggestions': {
    kind: 'field',
    title: 'Reklam önerileri',
    short:
      'Kampanya bazında kurallı bulgular: siparişsiz harcama, ROAS 1\'in altında, düşük tıklama oranı, büyütülebilir kampanya ve anomaliler. "Yapay zekâ ile özetle" bulguları yalnızca bu sayılarla önceliklendirir.',
    dataChanged: 'Hiçbir reklam, bütçe veya yayın değişmez.',
    guideUrl: `${G}#taslaklar`,
  },
  'ai.draft_ad_copy': {
    kind: 'field',
    title: 'Reklam metni taslağı',
    short:
      'Seçilen ürün için Google duyarlı arama reklamı (başlık ≤ 30, açıklama ≤ 90 karakter) veya Meta reklamı metinleri. Sınırı aşan satırlar atılır.',
    dataChanged: 'Reklam oluşturulmaz; metni kopyalayıp reklam platformunda kullanırsınız. Ücretli istektir.',
    guideUrl: `${G}#taslaklar`,
  },
  'page.ai_copilot': {
    kind: 'page',
    title: 'Copilot (iş asistanı)',
    short:
      'Satış, marj, iade, stok, SEO, müşteri segmenti ve reklam verilerinizden hesaplanan içgörüler ve bu verilerle yanıt veren asistan.',
    whatItDoes:
      'İçgörüler yapay zekâ kullanmadan, gerçek siparişlerden ve kayıtlardan hesaplanır (ücretsiz). Soru sorduğunuzda yalnızca bu hesaplanmış veriler (müşteri adı, e-posta, adres yok) sağlayıcıya gider; Copilot veri yoksa bunu söyler ve hiçbir kaydı değiştirmez. Yetkiniz olmayan bölümler (ör. maliyet) hesaplanmaz ve gönderilmez.',
    whenToUse: 'Haftalık/aylık değerlendirmede, satış düştüğünde veya yönetim özeti hazırlarken.',
    dataChanged: 'Hiçbir veri değişmez. Sorular kullanım raporuna yazılır; konuşma sunucuda saklanmaz.',
    requiredPermission:
      'Satış raporlarını görüntüleme; soru sormak için ayrıca Yapay zekâ ile taslak üretme.',
    guideUrl: `${G}#copilot`,
  },
  'copilot.insights': {
    kind: 'field',
    title: 'İçgörüler',
    short:
      'Seçili dönem ile önceki eşit dönemin karşılaştırması ve kurallı bulgular (gelir, sepet, düşüşe katkı yapan ürünler, iade, marj, siparişsiz günler, stok, SEO, segment, reklam).',
    guideUrl: `${G}#copilot`,
  },
  'copilot.report': {
    kind: 'action',
    title: 'Yönetim raporu olarak kopyala',
    short:
      'İçgörüleri madde madde düz metin olarak panoya kopyalar (e-postaya veya mesaja yapıştırmak için).',
    guideUrl: `${G}#copilot`,
  },
  'copilot.ask': {
    kind: 'action',
    title: "Copilot'a sorun",
    short:
      'Soruyu ve hesaplanmış veri paketini kısa ve somut yanıt için sağlayıcıya gönderir. Ücretli istektir; işlem yapmaz.',
    guideUrl: `${G}#copilot`,
  },
  'copilot.profit': {
    kind: 'field',
    title: 'Net kâr',
    short:
      'Finans raporundaki kârlılık hesabı (KDV hariç, Türk lirası): brüt kâr − kargo − ödeme komisyonu − reklam − kaybedilen itirazlar − işletme giderleri. Bu dönem ve önceki eşit dönem; yalnızca finans raporu yetkisi olana görünür.',
    guideUrl: `${G}#copilot`,
  },
  'page.ai_seo': {
    kind: 'page',
    title: 'SEO önerileri',
    short:
      'Anahtar kelime kümeleri, konu haritası, uzun kuyruklu aramalar, içerik boşlukları ve Google ürün başlıkları.',
    whatItDoes:
      'Öneriler yapay zekâ kullanmadan, anahtar kelime havuzunuzdan ve Search Console verisinden (son 28 gün) hesaplanır. Kümeler kelime köklerinin benzerliğiyle bulunur; konu haritası her kümenin ana sayfasını ve destek içeriklerini, destek yazısından ana sayfaya iç bağlantı olup olmadığını gösterir. Google başlığında isteğe bağlı yapay zekâ önerisi vardır.',
    whenToUse: 'İçerik planı yaparken ve Merchant Center başlıklarını iyileştirirken.',
    dataChanged:
      'Yalnızca "uygula", "havuza ekle", "proje oluştur" ve başlık kaydı veri değiştirir (denetim kaydına düşer).',
    requiredPermission: 'SEO görüntüleme / düzenleme; Google başlığı için ürün görüntüleme / düzenleme.',
    guideUrl: `${G}#seo-onerileri`,
  },
  'seo_ai.clusters': {
    kind: 'field',
    title: 'Otomatik kümeler',
    short:
      'Kökleri en az yarı yarıya örtüşen (veya birbirini kapsayan) kelimeler aynı kümeye önerilir; küme adı en çok gösterim alan kelimedir. Seçtiklerinizi havuza uygular.',
    guideUrl: `${G}#seo-onerileri`,
  },
  'seo_ai.topics': {
    kind: 'field',
    title: 'Konu haritası',
    short:
      'Her kümenin ana kelimesi ve sayfası (pillar), destek içerikleri ve destek blog yazısının ana sayfaya bağlantı verip vermediği.',
    guideUrl: `${G}#seo-onerileri`,
  },
  'seo_ai.long_tail': {
    kind: 'field',
    title: 'Uzun kuyruklu aramalar',
    short:
      'Havuzda olmayan, en az 3 kelimelik ve 10+ gösterim alan Search Console aramaları; niyet tahmini ifadelerden yapılır.',
    guideUrl: `${G}#seo-onerileri`,
  },
  'seo_ai.gaps': {
    kind: 'field',
    title: 'İçerik boşlukları',
    short:
      'Hedef sayfası olmayan havuz kelimeleri. "Makale projesi oluştur" İçerik Stüdyosu\'nda kelimeye bağlı proje açar.',
    guideUrl: `${G}#seo-onerileri`,
  },
  'seo_ai.merchant_titles': {
    kind: 'field',
    title: 'Google ürün başlıkları',
    short:
      'Başlık kuralları denetlenir ve kural tabanlı öneri verilir (marka + ürün adı + tür + miktar). "Yapay zekâ ile başlık" ücretli öneri üretir; hiçbiri sizin onayınız olmadan kaydedilmez.',
    guideUrl: `${G}#seo-onerileri`,
  },
  'page.ai_ltv': {
    kind: 'page',
    title: 'Tahmini müşteri değeri',
    short:
      'Müşterilerin önümüzdeki 12 ayda beklenen harcaması (LTV), segmentlere göre ortalamalar, en değerli müşteriler ve reklamla edinme maliyeti karşılaştırması.',
    whatItDoes:
      'Yapay zekâ kullanmaz. İki ve daha fazla siparişi olan müşteride kendi sipariş aralığı, tek siparişlide işletmenin tekrar alım oranı kullanılır; son siparişten bu yana geçen süre aralığın 1,5 katını aşınca "hâlâ müşteri" olasılığı azalır. Beklenen harcama = beklenen sipariş × müşterinin ortalama sipariş tutarı.',
    whenToUse:
      'Sadakat ve geri kazanım kampanyalarına öncelik verirken, reklam bütçesini müşteri değeriyle karşılaştırırken.',
    dataChanged: 'Hiçbir veri değişmez.',
    requiredPermission:
      'Hedef kitle görüntüleme; müşteri adları için Müşteri görüntüleme; reklam karşılaştırması için Reklam görüntüleme.',
    guideUrl: `${G}#ltv`,
  },
  'ltv.model': {
    kind: 'field',
    title: 'Model',
    short:
      'Tahmin bir beklentidir, kesin değildir: mevsimsellik, kampanya ve fiyat değişikliği hesaba katılmaz. Tek siparişlilerde tahmin için en az 20 müşteri gerekir.',
    guideUrl: `${G}#ltv`,
  },
  'ltv.segments': {
    kind: 'field',
    title: 'Segmentlere göre',
    short:
      'RFM segmentlerinin ortalama geçmiş harcaması ve 12 aylık beklenen harcaması: hangi segmente yatırım yapılacağını gösterir.',
    guideUrl: `${G}#ltv`,
  },
  'page.ai_youtube': {
    kind: 'page',
    title: 'YouTube videoları',
    short:
      "Ürünlerde ve blog yazılarında kullanılan YouTube videolarının durumu (yayında, gömülemez, Türkiye'de engelli, kaldırılmış), süresi, kanalı ve kullanıldığı yerler.",
    whatItDoes:
      "YouTube Data API ile yalnızca herkese açık video bilgisi okunur (yapay zekâ değildir). Vitrinde ürün ve blog sayfalarına arama motorları için video bilgisi (VideoObject: küçük resim, yükleme tarihi, süre) eklenir; kaldırılmış, gömülmeye kapatılmış veya Türkiye'de engelli videolar vitrinde gösterilmez. Küçük resim yalnızca yapılandırılmış veride yer alır, sayfa açılışında YouTube'a istek gitmez.",
    whenToUse: 'Ürün ve blog videolarının hâlâ izlenebilir olduğunu kontrol ederken.',
    dataChanged: 'Ürün ve yazılar değişmez; yalnızca video bilgisi önbelleği güncellenir.',
    requiredPermission: 'SEO görüntüleme; senkron için SEO düzenleme.',
    guideUrl: `${G}#youtube`,
  },
  'youtube.connection': {
    kind: 'field',
    title: 'YouTube bağlantısı',
    short:
      "Google Cloud'da YouTube Data API v3'ü etkinleştirip bir API anahtarı oluşturun (IP kısıtı önerilir) ve Entegrasyonlar → YouTube Data API'ye girip test edin. Anahtar yoksa Kurulum Gerekli görünür; videolar vitrinde eskisi gibi gösterilir.",
    guideUrl: `${G}#youtube`,
  },
  'youtube.sync': {
    kind: 'action',
    title: 'Şimdi senkronla',
    short:
      "Kullanılan videoların bilgisi YouTube'dan hemen okunur (50 video başına 1 kota birimi; ücretsiz günlük kota 10.000). Her gece 05:50'de kendiliğinden yapılır.",
    guideUrl: `${G}#youtube`,
  },
  'youtube.videos': {
    kind: 'field',
    title: 'Kullanılan videolar',
    short:
      'Sorunlu videolar önce listelenir. Kaldırılmış veya gömülemeyen videoyu ilgili ürün veya yazıdan kaldırın ya da başka bir videoyla değiştirin.',
    guideUrl: `${G}#youtube`,
  },
} satisfies Record<string, HelpContent>;

type En = Pick<HelpContent, 'title' | 'short'> & Partial<Pick<HelpContent, 'whatItDoes'>>;

export const AI_HELP_EN: Record<keyof typeof AI_HELP_TR, En> = {
  'page.ai_settings': {
    title: 'AI settings',
    short: 'Turn AI on/off, monthly spending limit, models, price table and usage report.',
    whatItDoes:
      'AI is a paid external service (text: Anthropic Claude, images: OpenAI). Keys are entered on the Integrations screen; here the owner sets a monthly limit and gives explicit approval. Every request reserves its worst-case cost first and is not sent if the limit would be exceeded. Prompts and responses are not stored.',
  },
  'ai.enable': {
    title: 'Turn on AI',
    short:
      'Set a monthly spending limit and confirm you are turning on a paid service. Only then are requests sent.',
  },
  'ai.disable': { title: 'Turn off AI', short: 'No new requests are sent; settings and usage log are kept.' },
  'ai.limits': {
    title: 'Spending and request limits',
    short: 'The monthly limit is the estimated spend in USD; the daily limit is a request count.',
  },
  'ai.models': {
    title: 'Models',
    short: 'Text model for long texts, a cheaper model for short tasks, and the image model.',
  },
  'ai.prices': {
    title: 'Price table',
    short: 'Input and output price per 1M tokens (USD). Defaults come from the providers’ pricing pages.',
  },
  'ai.usage': {
    title: 'Usage report',
    short:
      'Every request sent: purpose, model, result, tokens, estimated cost, user, masked data and health claims.',
  },
  'ai.supportDrafts': {
    title: 'Customer message in support drafts',
    short: "If on, the customer's message is masked and sent for support reply drafts. Off by default.",
  },
  'page.ai_recommendations': {
    title: 'Product recommendations',
    short: 'Settings and results of "also bought", cart suggestions and "time to reorder".',
    whatItDoes:
      'Uses no AI and is free. Every night, product pairs bought together in paid orders of the last 365 days are computed. A relation is used only if at least 3 different customers bought both and it is more frequent than chance (lift > 1). With too little data the storefront section is hidden.',
  },
  'recommendations.run': { title: 'Compute now', short: 'Recompute without waiting for the nightly job.' },
  'recommendations.pairs': {
    title: 'Strongest relations',
    short: 'Distinct buyers, confidence and lift of each product’s strongest relation.',
  },
  'recommendations.settings': {
    title: 'Recommendation settings',
    short:
      'Sections on/off, period, minimum distinct buyers, minimum confidence, maximum per product, dealer orders.',
  },
  'page.ai_forecast': {
    title: 'Demand forecast',
    short: 'Forecast sales per variant, days of cover, suggested order quantity and expiry risk.',
    whatItDoes:
      'Uses no AI. Computed from weekly sales of real paid orders: exponential smoothing for regular sellers, Croston for intermittent ones. Reorder point = daily forecast × (lead time + safety days). No purchase order is created.',
  },
  'forecast.accuracy': {
    title: 'Forecast error (WAPE)',
    short:
      'How far the forecast made 4 weeks ago was from actual sales in the last 4 weeks. Lower is better.',
  },
  'forecast.table': {
    title: 'Forecast list',
    short: 'Out of stock and reorder items first. "Adjust" sets a product-specific lead time or excludes it.',
  },
  'forecast.on_order': {
    title: 'On order',
    short:
      'Units not yet received on purchase orders sent to suppliers; below it, units on requests not yet sent. Both are subtracted from the suggestion. Lead time comes from the latest supplier unless set per product.',
  },
  'forecast.settings': {
    title: 'Forecast defaults',
    short:
      'History, default lead time and safety days, review period, overstock threshold and dealer orders.',
  },
  'page.content_studio': {
    title: 'Content Studio',
    short:
      'Prepare articles in 27 steps: from topic and sources to outline, draft, SEO, images and quality check.',
    whatItDoes:
      'Each article is a project. Fields are filled by hand or with optional AI suggestions; duplicate check, source verification, link suggestions and quality check use no AI. When done, it is exported to the blog as a draft; publishing and approvals happen on the blog screen.',
  },
  'page.content_studio_project': {
    title: 'Article project',
    short: 'The 27 steps of an article: which are done and where AI was used.',
  },
  'studio.create': {
    title: 'New article project',
    short: 'Opens a new project; nothing changes in the blog.',
  },
  'studio.brief': {
    title: 'Topic and target',
    short: 'Question answered, audience, target country and search intent.',
  },
  'studio.keyword': {
    title: 'Keyword',
    short: 'The search the article targets; picking from the pool also sets the intent.',
  },
  'studio.health': {
    title: 'Health / supplement content',
    short: 'Sources become mandatory and the blog post needs veterinary expert approval.',
  },
  'studio.save': { title: 'Save', short: 'Saves the project; warns if someone else saved in the meantime.' },
  'studio.steps': {
    title: '27 steps',
    short: 'Computed from the saved data; the star marks steps where AI was used.',
  },
  'studio.sources': {
    title: 'Sources',
    short: 'Up to 20 sources. AI may cite only these and cannot invent sources.',
  },
  'studio.verify': {
    title: 'Verify sources',
    short:
      'Each source is opened by the server: reachability, redirect target and page title. Internal addresses are blocked.',
  },
  'studio.duplicates': {
    title: 'Duplicate check',
    short: 'Title similarity with the store’s posts and pages in the same language. Over 60% is a warning.',
  },
  'studio.ai_plan': {
    title: 'Plan and headings with AI',
    short: 'Paid request; counts toward the monthly limit.',
  },
  'studio.ai_draft': {
    title: 'Draft with AI',
    short: 'Markdown draft from the headings. Health claims are listed.',
  },
  'studio.draft': {
    title: 'Draft',
    short: 'Markdown; converted to the blog document on export. Raw HTML is not executed.',
  },
  'studio.links': {
    title: 'Internal links',
    short: 'Matching published products, categories and posts (no AI).',
  },
  'studio.related': { title: 'Related products', short: 'Shown under the blog post (max 8).' },
  'studio.ai_meta': {
    title: 'SEO suggestion with AI',
    short: 'SEO title, meta description, slug and tags (cheaper model).',
  },
  'studio.seo': { title: 'SEO fields', short: 'SEO title max 70, meta description max 170 characters.' },
  'studio.images': {
    title: 'Images',
    short: 'Cover and alt text are exported to the blog post. Every image needs alt text.',
  },
  'studio.quality': {
    title: 'Quality check',
    short:
      'Lengths, word count, heading structure, keyword, links, sources, alt texts, health claims and duplicates.',
  },
  'studio.export': {
    title: 'Export to blog post',
    short:
      'Creates or updates the blog draft. The live post does not change; publishing happens on the blog screen.',
  },
  'studio.disclosure': {
    title: 'AI assistance note',
    short: 'If AI was used for plan, draft or SEO, an "AI-assisted" note is added at the end. On by default.',
  },
  'studio.archive': {
    title: 'Archive project',
    short: 'Removes it from the list; the blog post is not affected.',
  },
  'studio.performance': {
    title: 'Performance',
    short: 'Search Console data of the live post: last vs previous 28 days and search queries.',
  },
  'studio.suggestions': {
    title: 'Update suggestions',
    short:
      'Rule-based: stale post, traffic drop, low CTR, near first page, uncovered queries, old source checks.',
  },
  'studio.ai_cover': {
    title: 'Cover image with AI',
    short:
      'Generates an original cover from your description (OpenAI Images). Paid request; the per-image cap is in settings.',
  },
  'studio.ai_image': {
    title: 'Content image with AI',
    short: 'Generates an original image for the article body (max 20).',
  },
  'studio.ai_alt': {
    title: 'Alt text with AI',
    short:
      'The image is shown to the short-task model and a one-sentence alt text is suggested. Check it before saving.',
  },
  'studio.provenance': {
    title: 'Source and licence',
    short:
      'Source, licence, credit and source URL of an uploaded image. The source of AI-generated images cannot be changed.',
  },
  'studio.insert_image': {
    title: 'Add to draft',
    short:
      'Adds the image as a line at the end of the draft; move it where you want. It becomes an image in the blog post.',
  },
  'ai.draft_product': {
    title: 'Description draft with AI',
    short:
      'Writes short and long descriptions from the product’s saved data. Invents nothing; warns about health claims.',
  },
  'ai.draft_translate': {
    title: 'Translate with AI',
    short:
      'Translates the sibling post in the selected language into this post’s language; links, images and structure are kept.',
  },
  'ai.draft_email': {
    title: 'Subject ideas with AI',
    short: 'Three subject lines, a preheader and an intro paragraph.',
  },
  'ai.draft_support': {
    title: 'Reply draft with AI',
    short:
      'Drafts a reply from the ticket subject, category, order status and recent messages. Hidden unless the owner enabled it.',
  },
  'ai.ad_suggestions': {
    title: 'Ad recommendations',
    short: 'Rule-based findings per campaign; "Summarise with AI" prioritises them using only these numbers.',
  },
  'ai.draft_ad_copy': {
    title: 'Ad copy draft',
    short:
      'Google responsive search or Meta ad copy for the selected product. Lines over the limit are dropped.',
  },
  'page.ai_copilot': {
    title: 'Copilot (business assistant)',
    short:
      'Insights computed from your sales, margin, refund, stock, SEO, segment and ad data, and an assistant that answers with that data.',
  },
  'copilot.insights': {
    title: 'Insights',
    short: 'Comparison with the previous equal period and rule-based findings.',
  },
  'copilot.report': { title: 'Copy as management report', short: 'Copies the insights as plain text.' },
  'copilot.ask': {
    title: 'Ask Copilot',
    short: 'Sends the question and the computed data pack. Paid request; takes no action.',
  },
  'copilot.profit': {
    title: 'Net profit',
    short:
      'The finance report profit calculation (excl. VAT, Turkish lira) for this and the previous period; visible only with finance report permission.',
  },
  'page.ai_seo': {
    title: 'SEO suggestions',
    short: 'Keyword clusters, topic map, long-tail searches, content gaps and Google product titles.',
  },
  'seo_ai.clusters': {
    title: 'Automatic clusters',
    short: 'Keywords whose stems overlap at least half are suggested as one cluster.',
  },
  'seo_ai.topics': {
    title: 'Topic map',
    short: 'Pillar page, supporting content and whether supporting posts link to the pillar.',
  },
  'seo_ai.long_tail': {
    title: 'Long-tail searches',
    short: 'Search Console searches with 3+ words and 10+ impressions not in the pool.',
  },
  'seo_ai.gaps': {
    title: 'Content gaps',
    short: 'Pool keywords without a target page; create a Content Studio project.',
  },
  'seo_ai.merchant_titles': {
    title: 'Google product titles',
    short:
      'Title rules checked with a rule-based suggestion; optional AI suggestion. Nothing is saved without you.',
  },
  'page.ai_ltv': {
    title: 'Predicted customer value',
    short:
      'Expected 12-month spend (LTV), averages by segment, most valuable customers and acquisition cost comparison.',
  },
  'ltv.model': {
    title: 'Model',
    short: 'An expectation, not a certainty; seasonality and campaigns are not modelled.',
  },
  'ltv.segments': { title: 'By segment', short: 'Average past and expected 12-month spend per RFM segment.' },
  'page.ai_youtube': {
    title: 'YouTube videos',
    short: 'Status, duration, channel and usage of the YouTube videos on products and blog posts.',
  },
  'youtube.connection': {
    title: 'YouTube connection',
    short: 'Enable YouTube Data API v3 in Google Cloud, create an API key and enter it under Integrations.',
  },
  'youtube.sync': {
    title: 'Sync now',
    short: 'Reads video details from YouTube now (1 quota unit per 50 videos).',
  },
  'youtube.videos': { title: 'Videos in use', short: 'Problem videos come first; remove or replace them.' },
};
